class MenuLinks {

	static getMenuLinks(app) {
		var menulinks = [];

		const appconfig = app.getConfig();
		const routesconfig = (appconfig.routes ? appconfig.routes : {});
		const hasquotes = (routesconfig.quotes && (routesconfig.quotes.disabled === true) ? false : true);
		const hasbounties = (routesconfig.bounties && (routesconfig.bounties.disabled === true) ? false : true);
		const hasdeeds = (routesconfig.deeds && (routesconfig.deeds.disabled === true) ? false : true);


		if (hasquotes) {
			menulinks.push({type:'separator'});
			menulinks.push({type:'click', route: 'quote', onclick: () => {this.app.gotoRoute('quote', {action: "create"});}, label: 'Create Quote'});
			menulinks.push({type:'link', route: 'quotes', label: 'Quotes'});
			menulinks.push({type:'link', route: 'orders', label: 'Orders'});
			menulinks.push({type:'link', route: 'invoices', label: 'Invoices'});
			menulinks.push({type:'link', route: 'paymentnotices', label: 'Payment Notices'});
		}

		if (hasbounties) {
			menulinks.push({type:'separator'});
			menulinks.push({type:'click', route: 'bounty', onclick: () => {this.app.gotoRoute('bounty', {action: "create"});}, label: 'Create Bounty'});
			menulinks.push({type:'link', route: 'bounties', label: 'Bounties'});
			menulinks.push({type:'link', route: 'claims', label: 'Claims'});
		}

		if (hasdeeds) {
			menulinks.push({type:'separator'});
			menulinks.push({type:'click', route: 'deed', onclick: () => {this.app.gotoRoute('deed', {action: "create"});}, label: 'Create Deed'});
			menulinks.push({type:'link', route: 'deeds', label: 'Deeds'});
		}

		// xtra routes
		let boot_webapp = app.boot_webapp;

		if (boot_webapp && boot_webapp.routes && boot_webapp.menulinks && boot_webapp.menulinks.xtra_menulinks) {
			try {
				const xtra_menulinks = boot_webapp.menulinks.xtra_menulinks;

				for (var i = 0; i < xtra_menulinks.length; i++) {
					let menulink_def = xtra_menulinks[i];

					if (menulink_def.disabled === true)
						continue;

					switch(menulink_def.type) {
						case 'separator':
							menulinks.push({type:'separator'});
							break;
						case 'link': {
								let route = menulink_def.route;
								let label = app.t(menulink_def.label);
								menulinks.push({type:'link', route, label});
							}
							break;
						default:
							break;
					}

				}

			}
			catch(e) {
				console.log('exception in MenuLinks.getMenuLinks for xtra menu links: ' + e);
			}
		}

		return menulinks;
	}
}

export default MenuLinks;